/* if the dimensions cookie is set then add it to the body attribute */
if (Cookies.get('dimensions')) {
  document.body.setAttribute('data-dimensions', Cookies.get('dimensions') );
}
if (gdprConsentCheck(['marketing_cookies'])) {
  /* if the phone number has been cached then use it from cookie so it's quicker */
  var tel = Cookies.getJSON('tel');
  if(tel && jQuery('body.retain-telephone').length == 1) {
    // temp conditional statement for crawley
    if(document.body.classList.contains("postid-9116") === false){
      jQuery('.mhMobile').append('<a class="from-cookie" href="' + tel.href + '" >' + tel.text + '</a>');
    }
    /* if on a page that shows the default number but we have a cookie then don't load from mediahawk */
    if( jQuery('.telephone-span--default.mhMobile').length > 0 ) {
      jQuery('.mhMobile').attr('class', 'mhMobile');
    }
    jQuery('.telephone-wrap').addClass('telephone-wrap--show');
  }
}